<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
    >
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model="queryParams.name"
          placeholder="请输入姓名"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd(true)"
          
        >新增</el-button>
      </el-col>
      <!-- // 批量删除1 -->
      <el-col :span="1.5">
        <el-button type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          @click="handleDeleteAll">删除</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="userList"  @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="用户名" prop="Account" />
      <el-table-column label="真实姓名" prop="RealName" :show-overflow-tooltip="true"  />
      <el-table-column label="电话" prop="Phone" :show-overflow-tooltip="true"  />
      <el-table-column label="操作" width="280"  align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope" >
          <el-button
            size="mini"
            type="text"
            icon="el-icon-tickets"
            @click="handleDetail(scope.row)"
           
          >详情</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
           
          >编辑</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            
          >删除</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-setting"
            @click="resetPassword(scope.row)"
            
          >重置密码</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-show="total>0"
      :total="total"
      :page-sizes="[2, 5, 10, 15]"
      layout="total, sizes, prev, pager, next, jumper"
      :page.sync="queryParams.pageIndex"
      :limit.sync="queryParams.pageSize"
      @pagination="handleQuery"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage1"
    />
      <!-- 详情 -->
      <el-dialog title="详情"  class="openDialog" :visible.sync="detailOpen" width="650px" append-to-body>
        <el-form  label-width="100px">
          <el-col :span="12">
          <el-form-item label="用户名:" >
            {{form.Account}}
          </el-form-item>
        </el-col>
          <el-col :span="12">
          <el-form-item label="真实名字:">
            {{form.RealName}}
          </el-form-item>
        </el-col>
          <el-col :span="12">
          <el-form-item label="电话:">
            {{form.Phone}}
          </el-form-item>
        </el-col>
          <el-col :span="12">
          <el-form-item label="是否锁定:">
            {{form.IsLock?'是':'否'}}
          </el-form-item>
        </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelDetail">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 添加或修改角色配置对话框 -->
      <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body class="search2">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-col :span="12">
        <el-form-item label="用户名" prop="Account">
          <el-input v-model="form.Account" placeholder="请输入用户名" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item v-if="title=='新增'" label="密码" prop="Password">
          <el-input v-model="form.Password" placeholder="请输入密码" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="真实名字" prop="RealName">
          <el-input v-model="form.RealName" placeholder="请输入真实名字" />
        </el-form-item>
      </el-col>
        <el-col :span="12">
        <el-form-item label="电话" prop="Phone">
          <el-input v-model="form.Phone" placeholder="请输入电话" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item v-if="title=='编辑'" label="是否锁定" prop="IsLock">
          <el-switch v-model="form.IsLock" ></el-switch>
        </el-form-item>
      </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    
    <!-- 重置密码 ，生成随机密码-->
    <el-dialog title="重置密码" :visible.sync="openResetPwd" width="500px" append-to-body>
      <el-form ref="resetPwd" :model="passform" label-width="80px">
        <el-form-item label="用户名">
          {{passform.Account}}
          </el-form-item>
          
        <el-form-item  label="新密码">
          <div class="code">
            <div class="codeInput">
              <el-input v-model="passform.newPwd" class="input" placeholder="请输入新密码" clearable></el-input>
            </div>
            <el-button class="codeBtn" @click="randomPwd" >生成</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmResetPass">确 定</el-button>
        <el-button @click="cancelResetPass">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addAdmin,listAdmin,editAdmin,deleteAdmin,detailAdmin,resetPwdAdmin } from "@/api/admin.js";
// import { listCompany } from "@/api/company.js";
// import { listRole } from "@/api/role.js";

export default {
  name:"user",
  data(){
    return{
      passform:{
        newPwd:'',
        Account:'',
        Id:''
      },
      companyList:[],
      currentPage1:1,
      defaultProps: {
        children: "children",
        label: "RoleName",
        disabled:function(data, node) {
          // 禁用回收站选项
          if (data.IsEnable === true) {
            return false
          }else{
            return true
          }
        }
      },
      queryParams:{
        pageIndex: 1,
        pageSize: 10,
        roleName: undefined,
      },
      loading:false,
      userList:[],
      total:0,
      open:false,
      detailOpen:false,
      title:'设置角色',
      form:{
        phone:'',
      },
      rules: {
        Account: [
          { required: true, message: "用户名不能为空", trigger: "blur" }
        ],
        Password: [
          { required: true, message: "密码不能为空", trigger: "blur" }
        ],
        RealName: [
          { required: true, message: "真实名字不能为空", trigger: "blur" }
        ],
        Phone: [
          { required: true, message: "电话不能为空", trigger: "blur" }
        ]
      },
      deptOptions:[],
      multipleSelection:[],
      Id:"",
      openResetPwd:false,
    }
  },
  methods:{
    cancelResetPass(){
      this.openResetPwd=false
    },
    confirmResetPass(){
      this.openResetPwd=false
      this.$confirm('重置密码后，用户将使用新密码登录，是否继续?', '提示', {}).then(async () => {
        const [res,err]=await resetPwdAdmin(this.passform)
        if(res.data.Code==1){
          this.$message.success(res.data.Message)
        }
      })
    },
    generatePassword() {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&amp;*()_+{}[]|\\;:\'&quot;,./&lt;&gt;?';
      let password = '';
      for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        password += chars[randomIndex];
      }
      return password;
    },

    randomPwd(){
      this.passform.newPwd=this.generatePassword()
    },
    resetPassword(val){
      this.openResetPwd=true
      this.passform.Account=val.Account
      this.passform.newPwd=''
      this.passform.Id=val.Id
    },
     // 批量删除1
     handleSelectionChange(val) {
      // this.copyTable = val; // 选择的数据存储到copyData中
      this.multipleSelection = val.map((item) => item.Id);
      // console.log(0,this.multipleSelection)
    },
    // 批量删除1
    handleDeleteAll () {
      var obj = this.multipleSelection
      if(obj.length==0){
        this.$message.error('请选择数据')
        return
      }
      this.$confirm('此操作将永久删除选中的用户信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
          var obj = this.multipleSelection
          // 批量删除1
          const [res, err] = await deleteAdmin(obj)
        
          this.handleQuery()

      })
    },
    formatt2(val){
      return val?.split('T')[0]+" "+val?.split('T')[1]
    },
    // async getlistCompany(){
    //   const [res,err]=await listCompany({pageSize:0,pageIndex:1})
    //   this.companyList=res.data.Data
    // },
    handleSizeChange(val) {
      this.queryParams.pageSize=val
      this.handleQuery()
    },
    handleCurrentChange(val) {
      this.queryParams.pageIndex=val
      this.handleQuery()
    },
    async handleQuery(){
      const [res,err]=await listAdmin({name:this.queryParams.name,pageSize:this.queryParams.pageSize,pageIndex:this.queryParams.pageIndex})
  
      this.userList=res.data.Data
      this.total=res.data.TotalCount
      
    },
    handleAdd(){
      
      this.title='新增'
      this.open=true
      this.form={}
      // 
    },
    async handleDetail(row){
      this.detailOpen=true
      const [res,err]=await detailAdmin(row.Id)
      let rowData=res.data.Data
      this.form=rowData
    },
    cancelDetail(){
      this.detailOpen=false
    },
    async handleUpdate(row){
      
      this.title='编辑'
      this.open=true
      this.$set(this,'form',{...row})
      this.resetForm()
    },
    handleDelete(row){
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const [res,err]=await deleteAdmin(row.Id)
        
          this.handleQuery()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    resetForm() {
        this.$refs.form?.resetFields();
      },
    submitForm(){
      
      this.$refs.form.validate(async (valid)=>{
        if (valid) {
          if(this.form.Id){
            let item=JSON.parse(JSON.stringify(this.form))
            const [res,err]=await editAdmin(item)
          }else{
            const [res,err]=await addAdmin(this.form)
          }
          this.handleQuery()
          this.open=false
        }
      })
    },
    cancel(){
      this.resetForm()
      this.open=false
    },
    
  },
  async mounted(){
    // this.getlistCompany()
    this.handleQuery()
  }
}
</script>

<style scoped>
@import "../../assets/style/common.css";
:deep(.search2 .el-date-editor--daterange.el-input__inner){
  width:150px !important;
}
:deep(.search2 .el-input){
  width:150px !important;
}
.code{
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
}
.codeInput{
  height: 50px;
  background-color: #fff;
  width: 230px;
  line-height: 50px;
}
.codeBtn{
  margin-left: 10px;
}
</style>